<template>
  <div class="course-list">
    <Course
      v-for="item in courses" :key="item.courseId"
      :data="item" />

    <div class="course-none" v-if="!courses.length">
      <Divider>您还没有可以参加考试的课程</Divider>
    </div>
  </div>

 
</template>

<script>
import { mapActions } from 'vuex'
import { EXAMINATION } from '../../../libs/namespace'
import Course from '../components/Course'

export default {
  components: { Course },
  data () {
    return {
      courses: []
    }
  },
  async created () {
    this.courses = await this.fetchExamList()
  },
  methods: {
    ...mapActions(EXAMINATION, [ 'fetchExamList' ])
  }
}
</script>

<style lang="less" scoped>
.course-list {
  width: 600px;
  margin: auto;
}
.course-none {
  margin: 50px 0;
}
</style>
